import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment';
import { BTooltip } from 'bootstrap-vue'
import "../src/design/app.scss";

import store from '@/state/store'
import TextareaAutosize from 'vue-textarea-autosize'
import App from './App.vue'
import VueMousetrapPlugin from 'vue-mousetrap/vue2'
import tinymce from 'vue-tinymce-editor'
import money from 'v-money'
import vSelect from 'vue-select'
Vue.component('tinymce', tinymce)

Vue.component('b-tooltip', BTooltip)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.prototype.moment = moment;
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(TextareaAutosize)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
Vue.component('v-select', vSelect)
Vue.use(money, {
  thousands: ',',
  precision: 0,
});
Vue.filter('VND', function (value) {
  if(typeof value == 'undefined' || !value || value == null) return 0;
  return parseFloat(value).toLocaleString()
});
Vue.use(VueMousetrapPlugin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
window.mapStatus = function(data = ''){
  switch (data) {
    case 'new':
      return 'Mới';
    case 'confirm':
      return 'Đã xác nhận';
    case 'open':
      return 'Mới';
    case 'opening_control':
      return 'Mới & Chưa mở bán';
    case 'opened':
      return 'Đang mở bán';
    case 'closing_control':
      return 'Đã đóng & Chưa vào sổ';
    case 'closed':
      return 'Đã đóng & Đã vào sổ';
    case 'running':
      return 'Đang xử lý'
    case 'success':
      return 'Thành công'
    case 'error':
      return 'Lỗi'
    case 'ignore':
      return 'Ignore'
    case 'cancel':
        return 'Huỷ'
    case 'done':
        return 'Hoàn thành'
    case 'invoiced':
        return 'Hoàn thành'
    case 'sale':
        return 'Xác nhận'
    case 'draf':
        return 'Mới'
    default:
        return data;
  }
}
window.mapStatusTag = function(data) {
  switch (data) {
    case 'new':
      return 'warning';
    case 'opened':
      return 'secondary';
    case 'opening_control':
      return 'warning'
    case 'closing_control':
      return 'danger'
    case 'closed':
      return 'success';          
    case 'confirm':
      return 'success';
    case 'running':
      return 'secondary'
    case 'success':
      return 'success'
    case 'error':
      return 'danger'
    case 'ignore':
      return 'info'
    case 'cancel':
        return 'danger'
    case 'done':
        return 'success'
    case 'invoiced':
        return 'success'
    case 'sale':
        return 'info'
    case 'draf':
        return 'secondary'
    default:
      return 'secondary';
  }
}
window.capitalizeWords = function(text){
  return text.split(" ").map(element => {
    return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
  }).join(" ");
}